import React from 'react';
import { useAlert } from 'react-alert';
import { useTranslation } from 'react-i18next';
import BurgerMenu from '../../commons/BurgerMenu';
import Header from '../../commons/Header';
import { ReactComponent as IconBuilding } from '../../images/icn_buildings.svg';
import { Col, CustomInput, FormGroup, Label, Row } from 'reactstrap';
import {
  ContFilterYear,
  ContFlexRight,
  ContPaginationPage,
} from '../../styled-components';
import SearchInput from '../../commons/SearchInput';
import generateYearOptions from '../../lib/helpers/generateYearOptions';
import generateMonthOptions from '../../lib/helpers/generateMonthOptions';
import InsurancesTable from './InsurancesTable';
import Footer from '../../commons/Footer';
import generatePaginationOptions from '../../lib/helpers/generatePaginationOptions';
import TotalTr from './TotalTr';

const InsurancesPresentational = ({
  data,
  formattedData,
  query,
  total,
  onFilter,
}) => {
  const [t] = useTranslation('INSURANCES');
  const alert = useAlert();

  const { offset, limit, customerType, active } = query;

  const getTotals = (data) => {
    const shareToInvoiceTotals = data.reduce(
      (prev, cur) => prev + (cur.shareToInvoice || 0),
      0
    );
    const panoramicaShareTotals = data.reduce(
      (prev, cur) => prev + (cur.panoramicaShare || 0),
      0
    );
    const adminShareTotals = data.reduce(
      (prev, cur) => prev + (cur.adminShare || 0),
      0
    );
    const netTotals = data.reduce((prev, cur) => prev + cur.net, 0);
    const grossTotals = data.reduce((prev, cur) => prev + cur.gross, 0);

    return {
      shareToInvoiceTotals,
      panoramicaShareTotals,
      adminShareTotals,
      netTotals,
      grossTotals,
    };
  };

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section>
          <Header
            title={t('PAGES:INSURANCES')}
            icon={<IconBuilding fill="#ffffff" style={{ height: '25px' }} />}
          />

          <Row className="align-items-center">
            <Col className="">
              <ContFlexRight>
                Assicurazioni:&nbsp;<strong>{total}</strong>&nbsp;
              </ContFlexRight>
            </Col>
          </Row>

          <Row className="search-add-cont m-t-20" style={{ rowGap: '1rem' }}>
            <Col sm="12" md="6" lg="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>{t('START_DATE')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectinsuranceStartYear"
                        name="insuranceStartYear"
                        value={query && query.insuranceStartYear}
                        onChange={({
                          target: { value: insuranceStartYear },
                        }) => {
                          onFilter({ insuranceStartYear });
                        }}
                      >
                        {generateYearOptions(true)}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="6" lg="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>{t('COMMON:TITLE_FILTER_SIGNIN_MONTH')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="insuranceStartMonth"
                        name="insuranceStartMonth"
                        disabled={!query.insuranceStartYear}
                        value={query && query.insuranceStartMonth}
                        onChange={({
                          target: { value: insuranceStartMonth },
                        }) => onFilter({ insuranceStartMonth })}
                      >
                        {generateMonthOptions()}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="6" lg="3" xl="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>Tipologia cliente</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="customerType"
                        name="customerType"
                        value={customerType}
                        onChange={({ target: { value: customerType } }) =>
                          onFilter({ customerType })
                        }
                      >
                        <option value="" defaultChecked>
                          Tutti
                        </option>
                        <option value="condos">Condomini</option>
                        <option value="customerExtra">Clienti privati</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="6" lg="3" xl="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>Stato assicurazione</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="active"
                        name="active"
                        value={active}
                        onChange={({ target: { value: active } }) =>
                          onFilter({ active })
                        }
                      >
                        <option value="" defaultChecked>
                          Tutti
                        </option>
                        <option value="active">Attive</option>
                        <option value="terminated">Scadute</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.policy_code }}
                onFilter={({ search }) => onFilter({ policy_code: search })}
                label={t('SEARCH:POLICY_CODE')}
              />
            </Col>

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.admin_cf }}
                onFilter={({ search }) => onFilter({ admin_cf: search })}
                label={t('SEARCH:ADMINISTRATOR')}
              />
            </Col>

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.supplier }}
                onFilter={({ search }) => onFilter({ supplier: search })}
                label={t('SEARCH:SUPPLIER_INS')}
              />
            </Col>

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.customer }}
                onFilter={({ search }) => onFilter({ customer: search })}
                label={t('SEARCH:CUSTOMER')}
              />
            </Col>
          </Row>

          <section className="m-t-20">
            <InsurancesTable
              data={data}
              total={total}
              offset={offset}
              limit={limit}
              onFilter={onFilter}
              bottomRow={<TotalTr totals={getTotals(data)} />}
            />

            <ContPaginationPage>
              <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

              <FormGroup>
                <CustomInput
                  type="select"
                  className="pagination-select"
                  id="perPage"
                  name="perPage"
                  value={limit}
                  onChange={({ target: { value: limit } }) => {
                    onFilter({ limit: limit });
                  }}
                >
                  {generatePaginationOptions()}
                </CustomInput>
              </FormGroup>
            </ContPaginationPage>
          </section>
          <Footer />
        </section>
      </div>
    </div>
  );
};

export default InsurancesPresentational;
